export default __webpack_public_path__ + "static/media/RegisterImageResponsive.2a70175a.png";